import React from "react";

const testimonials = [
  {
    id: 0,
    snippet: "Nothing could have prepared us for just how breathtaking and magical our wedding day would be. The venue itself is straight out of a fairytale.",
    fullText: (
      <React.Fragment>
        <div className={"two-columns"}>
          <p>
            From the moment we first stepped into Shepstone Gardens, we knew we had found something truly special — but nothing could have prepared us for just how breathtaking and magical our wedding day would be.
          </p>
          <p>
            The venue itself is straight out of a fairytale. Every corner feels intentional, romantic, and beautifully curated — from the lush gardens to the stunning architecture. The layout flows so effortlessly, creating a natural journey throughout the day that made everything feel seamless, elegant, and perfectly timed. It genuinely felt like our dream had been brought to life in the most spectacular way.
          </p>
          <p>
            What truly sets Shepstone Gardens apart, though, is their incredible team.
            From start to finish, they went above and beyond in every possible way. Every detail — big and small — was handled with such care, professionalism, and warmth. They anticipated our needs before we even had to ask, ensuring that everything ran smoothly and that we could be fully present in every moment. The team made every effort to take off any stress or worry we had, and they succeeded.
          </p>
          <p>
            The level of coordination and attention to detail was simply exceptional. Everything came together effortlessly, creating an atmosphere that was not only beautiful but also calm, organized, and truly enjoyable. It felt like we were being looked after by people who genuinely cared about making our day as special as it could possibly be.
          </p>
          <p>
            And the florals… absolutely unforgettable.
            They were beyond anything we could have imagined — elegant, abundant, and perfectly aligned with our vision. Every arrangement added to the magic of the day and elevated the entire space into something truly extraordinary.
          </p>
          <p>
            A very special mention has to go to our wedding planner, Jessica Gaisford — who was nothing short of phenomenal. From the very beginning, she brought such a sense of calm confidence and creativity to the entire process. She truly thought of everything, guiding us through each step with care, insight, and genuine passion.
          </p>
          <p>
            Jessica didn’t just plan our wedding — she brought our vision to life in a way that exceeded anything we could have imagined. Every detail, every transition, every moment felt intentional and perfectly executed because of her. She catered to our every need and want with such grace and dedication, always making us feel heard, valued, and incredibly special.
          </p>
          <p>
            What stood out the most was how deeply she cared — not just about the event, but about us. She made us feel so supported, so celebrated, and so at ease throughout the entire journey. Having her by our side meant we could fully relax and soak in every second, knowing everything was in the best possible hands.
          </p>
          <p>
            The entire experience was made even more special by how personal and intentional everything felt. This wasn’t just another wedding — the team made us feel like our wedding truly mattered. Every detail reflected us, every space felt meaningful, and every moment felt thoughtfully considered.
          </p>
          <p>
            Shepstone Gardens didn’t just host our wedding — they created an experience. One that was seamless, magical, and filled with beauty from beginning to end.
          </p>
          <p>
            If you are looking for a venue that will not only meet your expectations but exceed them in every way, this is it.
          </p>
          <p>
            We will carry the memories of that day with us forever — and we are endlessly grateful to the entire team for making it so incredibly special.
          </p>
        </div>
        <p className={"test-full-name"}>Lara&Sayim</p>
      </React.Fragment>
    ),
    name: "Lara&Sayim",
    headImg: "/images/testimonials/Lara&Saayim.jpg",
  },
  {
    id: 1,
    snippet: "A masterclass in Hindu Wedding excellence. The team at Shepstone Gardens didn’t just meet our expectations—they redefined them.",
    fullText: (
      <React.Fragment>
        <div className={"two-columns"}>
          <p>
            A masterclass in Hindu Wedding excellence. Hosting a Hindu wedding requires a unique level of technical precision and cultural sensitivity, 
            and the team at Shepstone Gardens didn’t just meet our expectations—they redefined them. From the high-energy coordination of the Baraat and 
            the intricate timing of the Bride and Groom’s entries to the specialized requirements of a vegetarian banquet, the professionalism was flawless.
            A special thank you to the Event Team led by Jess, assisted by Riley and Kele. I must personally mention Nqobile, who technically supported the 
            actual event. Jess was just amazing. Her patience is legendary; she navigated 27 versions of our event document with grace and a smile until we 
            got every detail right.
          </p>
          <p>
            The Floral Team performed a miracle, curating a "romantic chic" look that felt truly magical. What impressed our guests 
            most was the progression of the event: the dinner banquet setting was a total transformation from the ceremony setting, offering an entirely new 
            atmosphere and experience as the evening unfolded. Shepstone’s ability to work seamlessly with both internal and external service providers took 
            the stress off our shoulders. If you are looking for a venue that understands the "heavy lifting" of a technically difficult wedding while maintaining 
            a romantic, high-end feel, look no further. Thank you for making my daughter’s special day an absolute triumph!
          </p>
        </div>
        <p className={"test-full-name"}>Minesh</p>
      </React.Fragment>
    ),
    name: "Minesh",
    headImg: "/images/testimonials/Minesh-2.jpg",
    // videoUrl: "https://www.youtube.com/embed/5saaUXI7d-E",
  },
  {
    id: 2,
    snippet: "We couldn't have asked for a more perfect wedding day! Thank you so so much for absolutely everything you and your team did to make our wedding so incredibly special.",
    fullText: (
      <React.Fragment>
        <div className={"two-columns"}>
          <p>
            Lee and I couldn't have asked for a more perfect wedding day! Thank you so so much for absolutely everything you and your team did to make our wedding so 
            incredibly special and even more than what we had envisioned. We truly had the most amazing day/night and we really felt like everything went so smoothly - 
            huge thanks to YOU! Wedding planning is a stressful and overwhelming task and you helped take away some of that stress in whatever way you could.
          </p>
          <p>
            For this we are extremely grateful. The fact that you had GOOD in-house suppliers such as decor and DJ made it so much easier for us. We really felt like we 
            could trust you guys and like we had made the best decision when choosing Shepstone Gardens. All of our guests had such a good time and were only full of 
            compliments for the day, and we know this wouldn't have been possible without the help of you and the SG team.
          </p>
        </div>
        <p className={"test-full-name"}>Mishka & Lee</p>
      </React.Fragment>
    ),
    name: "Mishka & Lee",
    headImg: "/images/testimonials/Mishka&Lee.jpg",
    // videoUrl: "https://www.youtube.com/embed/5saaUXI7d-E",
  },
  {
    id: 3,
    snippet: "Making a vision come to life as ethereal as ours, you have to have passion and love for what you do, and it is so easy to miss the finer details when overwhelmed by the beauty of Shepstone Gardens.",
    fullText: (
      <React.Fragment>
        <div className={"two-columns"}>
          <p>
            Making a vision come to life as ethereal as what we had, you could tell that there is passion and love for what you do, and it is so easy to miss the finer details 
            when overwhelmed by the beauty of Shepstone and emotions on the day. Jessica, our bubbly-as-ever coordinator with an upbeat spirit and carefree laugh kept me from 
            losing it a few times when chaos set in. Mira & her team sourced, and set up the aesthetic. I was in awe of the creations and what she did for us.
          </p>
          <p>
            Shepstone Gardens became more than a venue, it transformed into our Olympus, not only for how gorgeous it is, but because they were able to capture us with their 
            unbeatable team of wizards. Thank you for creating and being witness to our cheesy love story. Your staff are the friendliest and most professional people. We 
            honestly appreciate them. Thank you endlessly to everyone who was there from your side, who gave a piece of themselves to make our day that spectacular. We adore you.
          </p>
        </div>
        <p className={"test-full-name"}>Steph & Estaschia</p>
      </React.Fragment>
    ),
    name: "Steph & Estaschia",
    headImg: "/images/testimonials/Steph&Estaschia.jpg",
    // videoUrl: "https://www.youtube.com/embed/5saaUXI7d-E",
  },
  {
    id: 4,
    snippet: "We fell in love with Shepstone Gardens the day we saw it and booked it immediately for our wedding day all the way back in 2019!",
    fullText: (
      <React.Fragment>
        <div className={"two-columns"}>
          <p>
            Dean and I fell in love with Shepstone Gardens the day we saw it and booked it immediately for our wedding day all the way back in 2019! Always supportive, 
            understanding, accommodating, friendly, so patient and kind - the SG team made us feel like family. They made the planning process an easier one, the 
            postponement more bearable and our day nothing short of a perfect fairytale. Our guests & familywere amazed by the beauty of the venue and the 5-star service.
          </p>
          <p>
            Our wedding planner, Jess, went above and beyond for us! She is so much more than our planner, and more of our friend. Mira made our vision a reality and Ken 
            was always so fun, warm and helpful! Shepstone and the team will always have a very special place in our hearts and remain a huge part of our story!We are so 
            blessed and grateful to have had our fairytale come to life at the magical, transportive, most beautiful venue in JHB - Shepstone Gardens!
          </p>
        </div>
        <p className={"test-full-name"}>Dean & Andy</p>
      </React.Fragment>
    ),
    name: "Dean & Andy",
    headImg: "/images/testimonials/Dean&Andy.jpg",
    // videoUrl: "https://www.youtube.com/embed/5saaUXI7d-E",
  },
  {
    id: 5,
    snippet: "A huge thank you to the wonderful people at Shepstone Gardens: the high walled palace I cycled past hundreds of times which would become the place where our dreams became reality.",
    fullText: (
      <React.Fragment>
        <div className={"two-columns"}>
          <p>
            A huge thank you to the wonderful people at Shepstone Gardens: the high walled palace I cycled past hundreds of times which would become the place 
            where our dreams became reality. From the moment we arrived for a viewing on day one, to when we left after our wedding with a lifetime of memories 
            and tears in our eyes, everything was beyond perfect. What a day, what an event! Thank you all for your patience, encouragement and support through 
            COVID-19 as well.
          </p>
          <p>
            You took an inconsolable bride-to-be on 24 April 2020 and created a fairy tale wedding on 10 April 2021 – one year later. The biggest 
            thank you goes to Karine. She read us perfectly from day one and helped every second along the way. She gave us the chance to be part of it all: to breath, 
            to take it all in, to enjoy the day. She was present but never there. Her pink dress, sneakers and little bag on a bar stool just making it happen! She is 
            now family and so is Shepstone Gardens. You turned my fiancé’s hopes into the princess wedding she deserved.
          </p>
        </div>
        <p className={"test-full-name"}>Ferdie & Jeanette</p>
      </React.Fragment>
    ),
    name: "Ferdie & Jeanette",
    headImg: "/images/testimonials/Ferdie&Jeanette.jpg",
    // videoUrl: "https://www.youtube.com/embed/5saaUXI7d-E",
  },
  {
    id: 6,
    snippet: "I completely fell in love with Shepstone Gardens the moment I saw it on Pinterest; and I could not believe my eyes when I saw that this Italian-archictural jewel was so close to home!",
    fullText: (
      <React.Fragment>
        <div className={"two-columns"}>
          <p>
            I completely fell in love with Shepstone Gardens the moment I saw it on Pinterest; and I could not believe my eyes when I saw that this Italian-archictural 
            jewel was so close to home! Shepstone was the first and only venue my husband and I visited. We instantly knew that no other venue would be able to create 
            the same picture we had for confessing our love!
          </p>
          <p>
            From our first visit to the last minute of our wedding day, the Shepstone team was absolutely lovely! With 
            Jessica Gaisford as my wedding coordinator and Mira Cameron as my florist, we received endless support through the uncertain time of Covid-19. We got our 
            most perfect day! Their passion and dedication is inspiring and my flowers were out of this world!
          </p>
        </div>
        <p className={"test-full-name"}>Paula & Ruan</p>
      </React.Fragment>
    ),
    name: "Paula & Ruan",
    headImg: "/images/testimonials/Paula&Ruan.jpg",
    // videoUrl: "https://www.youtube.com/embed/5saaUXI7d-E",
  },
  {
    id: 7,
    snippet: "Sinead was literally the wedding planner I had always prayed for. One of the most common questions I got asked during the build-up to the wedding was “are you stressed?” and every time I was able to say “no”.",
    fullText: (
      <React.Fragment>
        <div className={"two-columns"}>
          <p>
            Sinead was literally the wedding planner I had prayed for from the minute we decided that we wanted a wedding planner. I say this confidently because one of 
            the most common questions I got asked during the build-up to the wedding was “are you stressed?” and every time I was able to say “no”. Sinead is not only 
            super organized, pro-active and a smart creative, but she is always humble, patient and kind. She came up with amazing ideas to bring our dream wedding to 
            life and always stayed on top of her tasks, constantly providing feedback to put us at ease.
          </p>
          <p>
            Needless to say, our wedding was talked about for quite some 
            time, we still get people in awe of how amazing it looked and what a great time everyone had. Sinead is a true gem as a wedding planner and if we could, 
            we would get married all over again just to work with her again. We are going to miss all the jokes, chuckles and memes we shared, and most importantly, 
            the words of encouragement. No amount of words can describe what an amazing wedding planner she is!
          </p>
        </div>
        <p className={"test-full-name"}>Tshidi & Mak</p>
      </React.Fragment>
    ),
    name: "Tshidi & Mak",
    headImg: "/images/testimonials/Tshidi&Mak.jpg",
    // videoUrl: "https://www.youtube.com/embed/5saaUXI7d-E",
  },
  {
    id: 8,
    snippet: "Thank you a million times over for the incredible job you all did, and the fact that you went over and above to make us feel special.",
    fullText: (
      <React.Fragment>
        <div className={"two-columns"}>
          <p>
            Thank you a million times over for the incredible job you all did, and the fact that you went over and above to make us feel special. 
            I have never met people with bigger hearts than all of you, 
          </p>
          <p>
            and we will forever be so grateful for how blessed we were to have you play such a huge role in making our day so filled with blessings.
          </p>
        </div>
        <p className={"test-full-name"}>Jenna & Luca</p>
      </React.Fragment>
    ),
    name: "Jenna & Luca",
    headImg: "/images/testimonials/Jenna&Luca.jpg",
    // videoUrl: "https://www.youtube.com/embed/5saaUXI7d-E",
  },
];

export default testimonials;